<template>
  <div v-if="isShow">
    <header>
      新規登録
      <div class="h-right">
        <a @click="$emit('close', formData)"
          ><img src="~@/assets/images/icon01.svg"
        /></a>
      </div>
    </header>
    <div id="wrap">
      <div class="reg2-1">あなたの情報を登録しましょう</div>

      <div class="cp_iptxt">
        <input
          autocomplete="off"
          type="text"
          name="displayname"
          v-model="formData.displayname"
          placeholder="ニックネーム"
        />
        <i class="fas fa-user fa-lg fa-fw" aria-hidden="true"></i>
      </div>

      <div class="cp_iptxt">
        <div class="select">
          <select v-model="formData.birthday_year"  @change="checkTime">
            <option :value="null" disabled selected>-</option>
            <option
              v-for="item in parseInt(new Date().getFullYear()) - 17 - parseInt(new Date().getFullYear()) + 122"
              :key="parseInt(new Date().getFullYear()) - 17 - item"
              :value="parseInt(new Date().getFullYear()) - 17 - item"
            >
              {{ parseInt(new Date().getFullYear()) - 17 - item }}
            </option>
          </select>
          年
          <select v-model="formData.birthday_month"  @change="checkTime">
            <option :value="null" disabled selected>-</option>
            <option
              v-for="item in 12"
              :value="item"
              :key="item"
              :disabled="
                checkBirthdayMonth(item, formData.birthday_year) ? false : true
              "
            >
              {{ item }}
            </option>
          </select>
          月
          <select v-model="formData.birthday_day">
            <option :value="null" disabled selected>-</option>
            <option
              v-for="item in daysInMonth"
              :value="item"
              :key="item"
              :disabled="
                checkBirthdayDate(
                  item,
                  formData.birthday_month,
                  formData.birthday_year
                )
                  ? false
                  : true
              "
            >
              {{ item }}
            </option>
          </select>
          日
          <i
            class="fas fa-birthday-cake fa-lg fa-fw ll2"
            aria-hidden="true"
          ></i>
        </div>
      </div>
      <div class="cp_iptxt">
        <div class="select">
          <div class="c-block-input">
            <div class="c-block-input__items">
              <div class="c-block-input__radio">
                <input
                  type="radio"
                  name="sex"
                  id="sex_male"
                  value="0"
                  v-model="formData.sex"
                  checked
                />
                <label for="sex_male">男性</label>
                <input
                  type="radio"
                  name="sex"
                  id="sex_female"
                  value="1"
                  v-model="formData.sex"
                />
                <label for="sex_female">女性</label>
              </div>
            </div>
          </div>
          <i class="fas fa-venus-mars fa-lg fa-fw ll2" aria-hidden="true"></i>
        </div>
        <div class="cp_iptxt">
          <div class="select">
            <select v-model="formData.living_area">
              <option :value="null" disabled selected>居住地</option>
              <option
                v-for="(item, index) in livingAreas"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </option>
            </select>
            <i
              class="fas fa-map-marker-alt fa-lg fa-fw ll2"
              aria-hidden="true"
            ></i>
          </div>
        </div>
        <div class="cp_iptxt">
          <input
            type="password"
            name="password"
            v-model="formData.password"
            placeholder="パスワード ※半角英数字8文字以上"
          />
          <i class="fas fa-key fa-lg fa-fw" aria-hidden="true"></i>
        </div>
        <div class="cp_iptxt">
          <input
            type="text"
            name="ads_code"
            placeholder="紹介コード"
            v-model="formData.ads_code"
            autocomplete="off"
          />
          <i class="fas fa-ticket-alt fa-lg fa-fw" aria-hidden="true"></i>
        </div>
      </div>

      <div :class="checkFormData() ? 'btn1' : 'btn3'" id="btn_register">
        <a @click="submit()">次へ</a>
      </div>
    </div>
  </div>
  
</template>

<script>
import { mapGetters } from "vuex";
import mixin from "@/mixin";

export default {
  props: {
    dataPersional: Object,
    isShow: Boolean,
  },
  mixins: [mixin],
  data: () => ({
    formData: {
      displayname: null,
      birthday_year: null,
      birthday_month: null,
      birthday_day: null,
      sex: 0,
      password: null,
      ads_code: null,
      living_area: null,
    },
    isNext: false,
    daysInMonth: new Date(parseInt(new Date().getFullYear()) - 18, 1, 0).getDate()
  }),
  mounted() {
    if (this.dataPersional) {
      this.formData = this.dataPersional;
    }
    this.checkFormData();
        
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)
  },
  computed: {
    ...mapGetters(["metadata"]),
    livingAreas() {
      if (
        this.metadata &&
        this.metadata.user_profile_list &&
        this.metadata.user_profile_list.living_area
      ) {
        return this.metadata.user_profile_list.living_area;
      }
      return [];
    },
  },
  methods: {
    checkFormData() {
      if (
        !this.formData.displayname ||
        !this.formData.birthday_year ||
        !this.formData.living_area ||
        !this.formData.birthday_month ||
        !this.formData.birthday_day ||
        !this.formData.password ||
        this.formData.password.length < 8
      ) {
        return false;
      }
      return true;
    },
    submit() {
      if (this.checkFormData()) {
        this.$emit("next", this.formData);
      }
    },
    checkTime() {
      this.daysInMonth = new Date(this.formData.birthday_year, this.formData.birthday_month, 0).getDate();
      if (parseInt(new Date().getFullYear()) - 18 > parseInt(this.formData.birthday_year)) {
        return true;
      }
      if (parseInt(new Date().getFullYear()) - 18 === parseInt(this.formData.birthday_year)) {
        if (parseInt(new Date().getMonth()) + 1 >= parseInt(this.formData.birthday_month)) {
          if (parseInt(new Date().getMonth()) + 1 === parseInt(this.formData.birthday_month)) {
            if (parseInt(new Date().getDate()) > this.formData.birthday_day) {
              return true;
            } else {
              this.formData.birthday_day = 1;
            }
          }
        } else {
          this.formData.birthday_month = 1;
        }
        // if (parseInt((new Date).getMonth()) < mounth) {
        //     return false
        // }
      }
    },
  },
};
</script>
<style scoped>
input,
select {
  appearance: auto;
}
</style>
